export const CONCIERGE_TRACKING_EVENTS = {
  NAV_ITEM_CLICKED: "concierge_nav_item_clicked",
} as const;
